export class ElementExplorer {
  
  
  
  
  constructor(_options) {
    this.debug = _options?.debug ?? false
    this.focusPointClass = _options?.focusPointClass ?? ''
    
    this.$explored = document.querySelector('[data-explore-me]')
    this.$wrapper = document.querySelector('[data-explore-wrapper]')
    
    this.console = {
      log: (smth) => console.log(`%c${smth}`, 'color:yellow')
    }
    
    
    if (this.debug) this.console.log(this.$explored.dataset.draggable)
//     if (this.$explored.dataset.draggable === 'true') {
      
//       this.currentTranslateX = 0
//       this.currentTranslateY = 0
      
//       this.$explored.addEventListener('mousedown', this.dragStart.bind(this))
//       this.$explored.addEventListener('touchstart', this.dragStart.bind(this))

//       document.addEventListener('mouseup', this.dragEnd.bind(this))
//       document.addEventListener('touchend', this.dragEnd.bind(this))
//     }
    
    this.focusPoints = {}
    
    
    this.registerExistingFocusPoints()
    
    if (!this.focusPoints['idle']) this.addFocusPoint({
      name: 'idle',
      x: 0.5,
      y: 0.5
    })
  }
  registerExistingFocusPoints() {
    this.$explored.querySelectorAll('[data-focus-point]').forEach($dot => {
      this.focusPoints[$dot.dataset.name] = {
        x: $dot.style.getPropertyValue('--x'),
        y: $dot.style.getPropertyValue('--y'),
        zoomFactor: $dot.style.getPropertyValue('--zoom-factor'),
        $el: $dot
      }
      $dot.addEventListener('click', () => {
        this.focusNamedPoint($dot.dataset.name)
      }, {capture: false, passive: true, once: false} || false)
    })
  }
  focus(sx = 0.5, sy = 0.5, dx = 0.5, dy = 0.5, zoomFactor = 1) {
    
    // this.$explored.style.setProperty('will-change', 'transform')
    
    const x = this.getMapTranslationToCenter(sx)
    const y = this.getMapTranslationToCenter(sy)
    
    const wrapperX = this.getWrapperTranslation(dx)
    const wrapperY = this.getWrapperTranslation(dy)
    
    const wrapperizedZoomX = this.computeWrapperizedAutozoom(sx, dx)
    const wrapperizedZoomY = this.computeWrapperizedAutozoom(sy, dy)
    const zoom = Math.max(wrapperizedZoomX, wrapperizedZoomY) * zoomFactor
    
    const zoomStr = `scale(${zoom})`
    this.$explored.style.transform = `${zoomStr} translate(${x}%, ${y}%)`
    this.$wrapper.style.transform = `translate(${wrapperX}%, ${wrapperY}%)`
    
    const $img = document.querySelector('[data-explore-me] > img')
    const imageAspectRatio = $img.naturalWidth / $img.naturalHeight
    const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
    const viewportHeight = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    const viewportAspectRatio = viewportWidth / viewportHeight
    // we know the $img (object-fit:cover) will always fill 100vw and 100vh
    
    const basedOnWidth = viewportWidth
    const basedOnHeight = Math.ceil(viewportHeight * imageAspectRatio * zoom)
    
    
    const sizes = `${Math.max(basedOnWidth, basedOnHeight)}px`
    $img.sizes = sizes
    
    this.$explored.style.setProperty('--map--scale', zoom);
    
    
    // window.setTimeout(() => this.$explored.style.setProperty('will-change', 'auto'), 2000)
  }
  addFocusPoint(pointData) {
    // create dot
    const $dot = document.createElement('button')
    if (this.focusPointClass) $dot.classList.add(this.focusPointClass)
    $dot.dataset.focusPoint = true
    $dot.style.setProperty('--x', pointData.x ?? 0.5)
    $dot.style.setProperty('--y', pointData.y ?? 0.5)
    
    const width = `${((pointData.endX ?? pointData.x) - pointData.x) * 100}%`
    const height = `${((pointData.endY ?? pointData.y) - pointData.y) * 100}%`
    $dot.style.setProperty('--width', width)
    $dot.style.setProperty('--height', height)
    
    $dot.dataset.name = pointData.name
    this.$explored.appendChild($dot)
    
    // register dot
    this.focusPoints[pointData.name] = {
      x: pointData.x,
      y: pointData.y,
      zoomFactor: $dot.style.getPropertyValue('--zoom-factor'),
      $el: $dot
    }
    $dot.addEventListener('click', () => this.focusNamedPoint(pointData.name), {capture: false, passive: true, once: false} || false)
  }
  getMapTranslationToCenter(sx) {
    const offsetRemoved =  0.5 - sx
    return offsetRemoved * 100
    // const truncated = this.round(offsetRemoved)
    // const asNegativePercents = truncated * -100
    // return asNegativePercents
  }
  getWrapperTranslation(dx = 0.5) {
    const offsetRemoved = dx - 0.5
    return offsetRemoved * 100
  }
  computeAutozoom(x) {
    if (this.debug) this.console.log(`computeAutozoom(${x})`)
    const minMargin = 50 - Math.abs(x)
    const whatShouldBeVisible = minMargin * 2
    const zoomFactor = 100 / whatShouldBeVisible
    return zoomFactor
  }
  computeWrapperizedAutozoom(x, wrapperX) {
    let altX = 1 - x
    let wrapperAltX = 1 - wrapperX
    let res = Math.max(wrapperX / x, wrapperAltX / altX)
    // let res = wrapperX / x
    if (this.debug) this.console.log(`computeWrapperizedAutozoom(${x},${wrapperX}) = ${res}`)
    return res
  }
  focusNamedPoint(name, dx = 0.5, dy = 0.5, zoomFactor = 1) {
    return this.focus(this.focusPoints[name].x, this.focusPoints[name].y, dx, dy, this.focusPoints[name].zoomFactor || zoomFactor)
  }
  reset() {
    return this.focusNamedPoint('idle')
  }
}